import { inject, Injectable } from '@angular/core';
import { EventBusService, EventPayload } from 'src/app/shared/services/event-bus.service';
import { CandidateSearchStore } from './candidate-search.store';
import { LocumsMarginCalculatorEvents } from 'src/app/recruiting/locums-margin-calculator/store/enums/locums-margin-calculator-events';
import { CandidateSearch } from 'src/app/recruiting/locums-margin-calculator/models/candidate-search.models';

@Injectable({ providedIn: 'root' })
export class CandidateSearchReducer {
    private readonly candidateSearchStore = inject(CandidateSearchStore);
    private readonly eventBus = inject(EventBusService);

    constructor() {
        this.listenToSearchEvent();
    }

    private listenToSearchEvent() {
        this.eventBus.on(LocumsMarginCalculatorEvents.CANDIDATE_SELECTED).subscribe((event: EventPayload) => {
            this.candidateSearchStore.setSelectedCandidate(event.payload as CandidateSearch);
        });

        this.eventBus.on(LocumsMarginCalculatorEvents.CANDIDATE_SELECTED_RESET).subscribe(() => {
            this.candidateSearchStore.clearSelectedCandidate();
            this.candidateSearchStore.setCandidates([]);
        });
    }
}
